var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.settings)?_c('v-col',{staticClass:"pr-0 pl-0",style:(("text-align:" + _vm.align)),attrs:{"cols":"12"}},[_c('CtaLinks',{attrs:{"links":[_vm.settings]}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }